import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import './helpers/access';
import App from './app';

ReactDOM.render(<App />, document.getElementById('root'));
